import { combineReducers } from "redux";

import * as actions from "../actions";

// 배송 환경설정 도메인 — ShippingConfig(스토어 단위 설정) + Carrier(택배사·내장 양식).
// productCode.js 선례의 소형 설정 도메인 패턴(status + 데이터 슬라이스, 뮤테이션 후
// saga 재조회로 갱신). ShipmentLabelTemplate 은 standalone 모델이 아니라
// Carrier.templates 내장 타입 — 양식 CRUD 는 전부 updateCarrier 로 수행.

const initialStatus = { isFetching: false, error: null };

function makeStatus(fetchingTypes, successType, failureType) {
  return function status(state = initialStatus, action) {
    if (fetchingTypes.includes(action.type)) {
      return { isFetching: true, error: null };
    }
    switch (action.type) {
      case successType:
        return { isFetching: false, error: null };
      case failureType:
        return { isFetching: false, error: action.error };
      default:
        return state;
    }
  };
}

// 조회(설정+택배사 동시 로드) 상태
const status = makeStatus(
  [actions.GET_SHIPPING_SETTINGS],
  actions.SET_SHIPPING_SETTINGS_STATUS_SUCCESS,
  actions.SET_SHIPPING_SETTINGS_STATUS_FAILURE,
);

// 저장 커맨드(설정 저장·택배사 등록/수정/삭제·양식 갱신·합포 설정 업데이트) 공용 상태 —
// 화면은 falling-edge + submitted 게이트로 자기 제출 건만 관찰(CS 패널 관례)
const saveStatus = makeStatus(
  [
    actions.SAVE_SHIPPING_CONFIG,
    actions.SAVE_SHIPPING_CARRIER,
    actions.DELETE_SHIPPING_CARRIER,
    actions.UPDATE_CARRIER_TEMPLATES,
    actions.UPDATE_SKU_MERGE_RULES,
    // 송장 양식 편집기 저장/복사/삭제 — isFetching 미토글로 저장 성공 감지가 안 되던 버그(무반응) 수정
    actions.SAVE_SHIPMENT_TEMPLATE,
    actions.COPY_SHIPMENT_TEMPLATE,
    actions.DELETE_SHIPMENT_TEMPLATE,
  ],
  actions.SET_SHIPPING_SETTINGS_SAVE_SUCCESS,
  actions.SET_SHIPPING_SETTINGS_SAVE_FAILURE,
);

// 미사용 송장(교체발번·송장삭제로 폐기된 번호 — CanceledWaybill 이력) 조회 상태·목록
const unusedStatus = makeStatus(
  [actions.GET_UNUSED_TRACKINGS],
  actions.SET_UNUSED_TRACKINGS_STATUS_SUCCESS,
  actions.SET_UNUSED_TRACKINGS_STATUS_FAILURE,
);

function unusedTrackings(state = null, action) {
  switch (action.type) {
    case actions.RECEIVE_UNUSED_TRACKINGS:
      return action.result || null;
    default:
      return state;
  }
}


// 합포 설정 현황 조회 상태(목록 로딩) — 설정 로드(status)와 분리
const mergeRulesStatus = makeStatus(
  [actions.GET_SKU_MERGE_RULES],
  actions.SET_SKU_MERGE_RULES_STATUS_SUCCESS,
  actions.SET_SKU_MERGE_RULES_STATUS_FAILURE,
);

// 합포 설정 현황 — {count, configuredCount, page, size, rows} 서버 응답 그대로
function mergeRules(state = null, action) {
  switch (action.type) {
    case actions.RECEIVE_SKU_MERGE_RULES:
      return action.result || null;
    default:
      return state;
  }
}

// 합포 설정 업데이트 결과 — {updated, cleared, failed} (부분 실패 보고용)
function mergeUpdateResult(state = null, action) {
  switch (action.type) {
    case actions.UPDATE_SKU_MERGE_RULES:
      return null; // 새 제출 시 이전 결과 클리어
    case actions.RECEIVE_SKU_MERGE_UPDATE_RESULT:
      return action.result || null;
    default:
      return state;
  }
}

// ShippingConfig — 스토어당 1건(byStore 첫 행). 없으면 saga 가 기본값으로 생성해 심음.
function config(state = null, action) {
  switch (action.type) {
    case actions.RECEIVE_SHIPPING_CONFIG:
      return action.config || null;
    default:
      return state;
  }
}

// Carrier 목록(templates 내장 포함) — byStore 전량
function carriers(state = [], action) {
  switch (action.type) {
    case actions.RECEIVE_SHIPPING_CARRIERS:
      return action.carriers || [];
    default:
      return state;
  }
}

export default combineReducers({
  status,
  saveStatus,
  config,
  carriers,
  mergeRules,
  mergeRulesStatus,
  mergeUpdateResult,
  unusedTrackings,
  unusedStatus,
});
